import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const catalogPublishManifest: FeatureManifest = {
  id: 'catalog-publish',
  path: 'catalogs/publish',
  navPath: '/catalogs/publish',
  label: 'Quản lý xuất bản',
  requiredPermissions: ['catalogs'],
  navigationGroup: { id: 'catalogs', label: 'Quản lý danh mục' },
  load: () => import('./entry'),
}
